import { KlicContact } from '../../interfaces/klic-contact.interface';
import { KlicBeheerder, KlicUtilityNetwork } from '../../interfaces/klic-utility-network.interface';
import { Log } from '../../interfaces/log.interface';
import { KlicPrecaution } from './selection.state.model';
import { UploadLogActionType } from '../../constants';

export interface KlicMetadataStateModel {
  utilityNetworks: KlicUtilityNetwork[];
  themes: string[];
  beheerders: KlicBeheerder[];
  precautions: KlicPrecaution[];
  contacts: KlicContact[];
  logs: Log[];
}

export class ListKlicMetadata {
  static readonly type = '[KlicMetadata] ListKlicMetadata';
  constructor(public payload: { uploadId: string }) {}
}

export class ListUploadLogs {
  static readonly type = '[KlicMetadata] ListUploadLogs';
  constructor(public payload: { uploadId: string; actionTypes: UploadLogActionType[] }) {}
}
